import { useState, useEffect } from 'react';

import ModalContext, {ModalContextProvider} from './store/ModalContext';
import QuestionView from './components/QuestionView';
import Questions from './question.json';
import FormularView from './components/FormularView';
import ZipView from './components/ZipView';

import "./App.css";

const allowedPlzArr = ["91080", "91054", "91052", "91058", "90427", "90411", "90491", "90489", "90482", "90480", "90478", "90471", "90562", "90571", "90475", "90552", "90607", "91207", "90542", "91220", "90610", "91227", "90518", "91242", "91245", "91241", "91247", "91224", "91230", "91238", "91217", "91244", "91233"];
const queryParams = new URLSearchParams(window.location.search);
const value = queryParams.get('source');

function App() {
  
  const [isAllowed, setIsAllowed] = useState(false);
  const [zipData, setZipData] = useState('');
  const [zipError, setZipError] = useState(
      {
        errorStatus: false,
        errorMessage: "",
        class: "",
      }
  );  
    
  const [appLocation, setAppLocation] = useState(value);
  const [typenschild, setTypenschild] = useState(false);
  const [nextQuestion, setNextQuestion] = useState(false);
  const [nextQuestionStatus, setNextQuestionStatus] = useState(false);

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [isOver, setIsOver] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState([]);
  const [selectedQuestionLength, setSelectedQuestionLength] = useState(0);
  const [progressBar, setProgressBar] = useState(0);
  const [questionList, setQuestionList] = useState(Questions);
  const [questionLength, setQuestionLength] = useState(Questions.length);

  const [saveQuestion, setSaveQuestion] = useState('');

  const [firstQuestion, setFirstQuestion] = useState(false);
    
  const [counter, setCounter] = useState(0);

  const handleQuestionSelectClick = (selected, modal = false) => {
    if(modal){
      return false;
    }
    let next = currentQuestion + 1;

    if(selected === "Holzbau/ Zimmerei/ Dachgaube"){
      setQuestionList(Questions[0].answers[0].questions);
      setQuestionLength(Questions[0].answers[0].questions.length);
      next--;setFirstQuestion(true);
    }else if(selected === "Dachdecken/ Dachsanierung"){
      setQuestionList(Questions[0].answers[1].questions);
      setQuestionLength(Questions[0].answers[1].questions.length); 
      next--;setFirstQuestion(true);
    }else if(selected === "Flachdach oder Garagendach"){
      setQuestionList(Questions[0].answers[2].questions);
      setQuestionLength(Questions[0].answers[2].questions.length);
      next--;setFirstQuestion(true);
    }else if(selected === "Dachreparatur/ Wartung"){
      setQuestionList(Questions[0].answers[3].questions);
      setQuestionLength(Questions[0].answers[3].questions.length);
      next--;setFirstQuestion(true);
    }else if(selected === "Dachfenster"){
      setQuestionList(Questions[0].answers[4].questions);
      setQuestionLength(Questions[0].answers[4].questions.length);
      next--;setFirstQuestion(true);
    }else if(selected === "PV-Anlagen"){
      setQuestionList(Questions[0].answers[5].questions);
      setQuestionLength(Questions[0].answers[5].questions.length);
      next--;setFirstQuestion(true);
    }else if(selected === "Sonstiges"){
      setQuestionList(Questions[0].answers[6].questions);
      setQuestionLength(Questions[0].answers[6].questions.length);
      next--;setFirstQuestion(true);
    }

    if(next < questionLength){
      setCurrentQuestion(next);
    }else{
      setIsOver(true);
    }
    if(next >= 1){
      progress();
    }
    window.scrollTo(0, 0);
    saveSelectedQuestion(selected);    

  };


  const handleNextLevelRequest = (selected, request, nextQuestions) => {    

    if(request !== undefined){
      setTypenschild(true);
    }
    if(nextQuestions !== undefined){
      setNextQuestionStatus(true);
    }

    saveSelectedQuestion(selected); 
  }

  const handleQuestionBackClickFirst = () => {
    window.scrollTo(0, 0);
    // setProgressBar(0);
    // setCurrentQuestion(0);
    // setSelectedQuestion([]);
    // setNextQuestionStatus(false);
    // setSaveQuestion('');
    setNextQuestion(false);
    setNextQuestionStatus(false);
    setCurrentQuestion(0);
    setIsOver(false);
    setSelectedQuestion([]);
    setSelectedQuestionLength(0);
    setProgressBar(0);
    setQuestionList(Questions);
    setQuestionLength(Questions.length);
    setSaveQuestion('');
    setFirstQuestion(false);

  }

  const handleQuestionBackClick = () => {

    const updateQuestions = [...selectedQuestion];

    window.scrollTo(0, 0);
    if(nextQuestionStatus){
      updateQuestions.splice(-2);
      setSelectedQuestion(updateQuestions);
      setNextQuestionStatus(false);
      return setIsOver(false);
    }

    if((questionLength +1) === selectedQuestionLength && isOver){
      updateQuestions.splice(-1);
      setSelectedQuestion(updateQuestions);
      setNextQuestionStatus(false);
      return setIsOver(false);
    }


    setCurrentQuestion(currentQuestion -1);
    updateQuestions.splice(-1);
    setSelectedQuestion(updateQuestions);
  
  
    setNextQuestionStatus(false);
    return setIsOver(false);
  }

  const saveSelectedQuestion = (selected) => {
    setSelectedQuestion([...selectedQuestion, selected]);
    console.log(selectedQuestion);
  };

  const progress = () => {
    const value = (currentQuestion + 1) / questionLength;
    setProgressBar(value);
  }

  const handleInputChangeZip = (e) => {
    const inputValue = zipData;
    setZipData(e.target.value);

    if(e.type === 'click'){
      if(allowedPlzArr.includes(inputValue)){
        setIsAllowed(true);
        window.scrollTo(0, 0);
      }else{
        setZipError(zipError => ({
            ...zipError,
            errorStatus: true, 
            errorMessage: "Sehr geehrter Interessent, leider liegt Ihr Bauvorhaben nicht in unserem Arbeitsradius. Bitte wenden Sie sich an einen Kollegen in Ihrer Nähe.",
            class: 'negative'
          })
        )
      }
    }
    if(allowedPlzArr.includes(e.target.value)){
      setZipError(zipError => ({
        ...zipError,
        errorStatus: true, 
        errorMessage: "Ihr Bauvorhaben liegt in unserem Arbeitsradius, Sie können jetzt auf ",
        class: 'positive'
        })
      )
    }
  }

  useEffect(() => {
    setSelectedQuestionLength(selectedQuestion.length);
  }, [selectedQuestion])


  useEffect(() => {
    if(isOver){
      document.body.classList.add('form-open');
    }else{
      document.body.classList.remove('form-open');
    }
  }, [isOver]);

  const modalAction = (title, modal = false, modalActionOpenFunc) => {
     if(modal){
      setSaveQuestion(title);
      modalActionOpenFunc(modal);
     }
  }

  const modalWaitForAction = (status, modalActionCloseFunc) => {
    if(status){
      handleQuestionSelectClick(saveQuestion);
      modalActionCloseFunc();
      setSaveQuestion('');
    }else{
      modalActionCloseFunc();
      setSaveQuestion('');
    }
  }

  return (
    <ModalContextProvider>
      <div className="App">
        {isAllowed ? (
          <div className="question-box">
            {isOver ? (
              <div className="formular-wrapper">
                <FormularView SelectedQuestion={selectedQuestion} />
              </div>
            ) : (
              <QuestionView
              Questions={questionList}
              currentQuestion={currentQuestion}
              handleQuestionSelectClick={handleQuestionSelectClick}
              handleNextLevelRequest={handleNextLevelRequest}
              progressBar={progressBar}
              questionLength={questionLength}
              typenschild={typenschild}
              nextQuestion={nextQuestion}
              nextQuestionStatus={nextQuestionStatus}
              modalAction={modalAction}
              modalWaitForAction={modalWaitForAction}
              appLocation={appLocation}
            />
            )}
            {currentQuestion >= 1 && <div className="back-btn"><button onClick={() => handleQuestionBackClick()}>Zurück</button></div>}
            {firstQuestion && <div className="back-btn back-btn2"><button onClick={() => handleQuestionBackClickFirst()}>Zurück</button></div>}
          </div>
        ) : (
          <div className="zip-handler">
            <ZipView 
              currentZip={zipData}
              handleZip={handleInputChangeZip}
            />
            <div className={`zip-message ${zipError.class}`}>
            {zipError.errorStatus ? zipError.errorMessage : null} {zipError.class == "positive" && <span style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={handleInputChangeZip}>weiter klicken!</span>}
            </div>
          </div>
        )
      }
      </div>
    </ModalContextProvider>
    );
}

export default App;
